import { createContext } from 'react';

import type { AuthServiceInterface } from '@mint-lib/api';

// @ts-ignore Value should be present
export const AuthContext = createContext<AuthServiceInterface>();
